import {nanoid} from "nanoid";
import { FieldTimeOutlined, FireOutlined, BankOutlined } from '@ant-design/icons';

const missions = [
    {
        id: nanoid(),
        icon: <FireOutlined />,
        title: "AVG # of Missions [Client]",
        value: "3 000",
        name: "avgMissionsCost"
    },
    {
        id: nanoid(),
        icon: <BankOutlined />,
        title: "Revenue per Mission",
        value: "1 200",
        name: "avgMissionsRevenue"
    },
    {
        id: nanoid(),
        icon: <FieldTimeOutlined />,
        title: "Avg / Total Mission Time",
        value: "4:32 / 820:22",
        name: "avgTime"
    },
];

const clients = [
    {
        id: nanoid(),
        icon: <BankOutlined />,
        title: "Revenue per Client",
        value: "3 000",
        name: "avgClientRevenue",
    },
    {
        id: nanoid(),
        icon: <BankOutlined />,
        title: "Revenue per Mission",
        value: "1 200",
        name: "avgMissionsRevenue"
    },
    {
        id: nanoid(),
        icon: <FieldTimeOutlined />,
        title: "Avg / Total Mission Time",
        value: "4:32 / 820:22",
        name: "avgTime"
    },
];

const delegates = [
    {
        id: nanoid(),
        icon: <BankOutlined />,
        title: "Revenue per Client",
        value: "3 000",
        name: "avgDelegateRevenue",
    },
    {
        id: nanoid(),
        icon: <BankOutlined />,
        title: "Revenue per Mission",
        value: "1 200",
        name: "avgMissionsRevenue"
    },
    {
        id: nanoid(),
        icon: <FieldTimeOutlined />,
        title: "Avg / Total Mission Time",
        value: "4:32 / 820:22",
        name: "avgTime"
    },
];

export default {
    missions,
    clients,
    delegates,
};
